<script>
    import { slide } from 'svelte/transition';

    import ItemHead from './item-head.svelte';
    import ItemBody from './item-body.svelte';

    export let item;

    let isOpen = false;

    function toggle() {
        isOpen = !isOpen;
    }

</script>

<li transition:slide class="ghwp-accordion__item" class:is-open={isOpen}>
    <ItemHead title={item.title} {isOpen} on:click={toggle} />
    {#if isOpen}
        <ItemBody {item} />
    {/if}
</li>
